export default __webpack_public_path__ + "0e91c96c372a792bb99f0d590420e976.png";